// The CHOICE contract every short-option control shares (brief §4.4) — one
// definition, no look of its own. AppSegmented (the brand TabSet track) and
// AppColorChips (dot + label chips) both extend it:
//
//   options   [{ value, label }] — label: a bundle key or a plain string
//   stateKey  the key of the nearest state that holds the value; a click
//             writes it (the house state contract, like AppPagination)
//
// Each option is a toggle button in a labelled group (role=group,
// aria-pressed). A call site with its own wiring overrides the options'
// isActive / ariaPressed / onClick through childProps.
export const AppChoiceGroup = {
  role: 'group',
  children: (el, s) => {
    const opts = typeof el.options === 'function' ? el.options(el, s) : el.options
    return (opts || []).map((o) => ({
      key: `opt-${o.value}`,
      optionValue: o.value,
      optionLabel: o.label
    }))
  },
  childProps: {
    isActive: (el, s) => {
      const key = el.parent?.stateKey
      return !!key && s?.[key] === el.optionValue
    },
    ariaPressed: (el, s) => {
      const key = el.parent?.stateKey
      return key && s?.[key] === el.optionValue ? 'true' : 'false'
    },
    onClick: (e, el, s) => {
      const key = el.parent?.stateKey
      if (key) s.update({ [key]: el.optionValue })
    }
  }
}
